import React from 'react';
import ReactDOM from 'react-dom/client';
import {THEME, TonConnectUIProvider} from '@tonconnect/ui-react';
import { Buffer } from 'buffer';

import './index.css';
import App from './App';

window.Buffer = Buffer;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <TonConnectUIProvider manifestUrl="https://raw.githubusercontent.com/ocherednoiscam/ocherednoiscam.github.io/main/tonconnect-manifest.json"
                          uiPreferences={{ theme: THEME.DARK }}>
        <App />
    </TonConnectUIProvider>
);